import { render } from "./CustomerProfile.vue?vue&type=template&id=0e714452&scoped=true"
import script from "./CustomerProfile.vue?vue&type=script&lang=js"
export * from "./CustomerProfile.vue?vue&type=script&lang=js"

import "./CustomerProfile.vue?vue&type=style&index=0&id=0e714452&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e714452"]])

export default __exports__